module.exports = __webpack_public_path__ + "static/img/ios4.b8b72e81.webp";